var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF","fillRule":"evenodd"},[React.createElement("path",{"d":"M8.5 14.69a6.19 6.19 0 1 1 0-12.38 6.19 6.19 0 0 1 0 12.38zm0-1.238a4.952 4.952 0 1 0 0-9.904 4.952 4.952 0 0 0 0 9.904z","key":0}),React.createElement("path",{"d":"M10.293 5.996a.591.591 0 1 1 .987.65L8.193 11.33a.591.591 0 0 1-.963.033L5.526 9.135a.591.591 0 0 1 .94-.718l1.198 1.568 2.63-3.99z","key":1})]));
}

Checkmark.displayName = "Checkmark";

Checkmark.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Checkmark;

Checkmark.default = Checkmark;



//////////////////
// WEBPACK FOOTER
// ./src/assets/my-tickets/checkmark.svg
// module id = 1873
// module chunks = 1 3 5 6 8 9 11 14 16